/* eslint-disable react/no-did-mount-set-state */
import React, {Component} from 'react';
import TimelineMilestones from "./TimelineMilestones";
import {twillBase} from '../../config/API';

class TimelineMilestoneQuery extends Component {

    static getMilestoneYears = async () => {
        const response = await fetch(`${twillBase}/api/milestone-years`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    }

    state = {
        loading: true,
        error: null,
        milestones: [],
    };

    async componentDidMount() {
        try {
            const apiData = await TimelineMilestoneQuery.getMilestoneYears();

            // Transform API response to match the structure expected by TimelineMilestones component
            const transformedMilestones = apiData
                .filter(item => item.published === 1)
                .map(item => ({
                    entityBundle: 'timeline_milestone',
                    id: String(item.id),
                    year: item.year,
                    title: item.title,
                    fieldBackgroundColor: item.background_color || '#333333',
                    fieldBackgroundImageMedia: item.background_image ? {
                        entity: {
                            fieldMediaImage: {
                                url: item.background_image,
                                alt: item.title
                            }
                        }
                    } : {},
                    fieldSupportingImageMedia: {},
                    fieldColumnContent: item.milestones.map(milestone => ({
                        value: milestone.milestone_content,
                        format: 'full_html',
                        processed: `<h2>${milestone.milestone_title}</h2>\n${milestone.milestone_content}`
                    }))
                }))
                .reverse();

            this.setState({
                loading: false,
                milestones: transformedMilestones
            });
        } catch (error) {
            console.error('Error fetching milestone data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    render() {
        const {loading, error, milestones} = this.state;

        if (loading) return (
            <div className="timelineMilestoneLoader">
                <span className="far fa-spin fa-spinner"/>
            </div>
        );

        if (error) {
            return <div>Error loading milestones: {error}</div>;
        }

        if (!milestones.length) return null;

        return (<TimelineMilestones milestones={milestones}/>);
    }
}

export default TimelineMilestoneQuery;



// WEBPACK FOOTER //
// ./frontend/components/TimelineMilestone/TimelineMilestoneQuery.jsx